<script lang="ts" setup>
import buildSearchUrl from '@/utils/filters/buildSearchUrl'
import TextWithHighlight from './TextWithHightlight.vue'
import buildManufacturerUrl from '~/utils/routing/buildManufacturerUrl'
import type { RouteLocationRaw } from 'vue-router'

interface IKeywordLinkProps {
  searchValue?: string
  suggestion: string
  url?: string
  manufacturers?: string[]
}

const props = defineProps<IKeywordLinkProps>()

const url = computed<RouteLocationRaw | string>(() => {
  if (props.url) {
    return props.url
  }

  if (props.manufacturers?.length) {
    const manufacturer = props.manufacturers.find(
      (manufacturer) => String(manufacturer).toLowerCase() === String(props.suggestion).toLowerCase()
    )

    if (manufacturer !== undefined) {
      return buildManufacturerUrl(manufacturer)
    }
  }

  return buildSearchUrl(props.suggestion)
})
</script>

<template>
  <NuxtLink class="suggestion-phrase" :to="url">
    <TextWithHighlight :search="props.searchValue" :text="props.suggestion" />
  </NuxtLink>
</template>
